import React, {FC} from 'react'
import NewProjectHeader from './NewPropjectHeader'
import {Outlet} from 'react-router-dom'
import {useThemeMode} from '../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

const NewEditProject: FC = () => {
  const {mode} = useThemeMode()
  return (
    <>
      <div
        className={'rounded py-5 ' + (mode === 'dark' ? ' bg-black ' : ' bg-white ')}
        data-bs-theme={mode}
      >
        <div className='d-none d-sm-none d-md-none d-lg-block d-xl-block'>
          <NewProjectHeader dType='large' />
        </div>
        <div className='d-block d-sm-block d-md-block d-lg-none d-xl-none'>
          <NewProjectHeader dType='small' />
        </div>
        <div
          data-bs-theme={mode}
          className={'rounded py-5 ' + (mode === 'dark' ? ' bg-black ' : ' bg-white ')}
        >
          <Outlet />
        </div>
      </div>
      <div style={{height: 50}}></div>
    </>
  )
}

export default NewEditProject
